export default function Invoices() {
  return <> Invoices </>;
}
